export default {
  title: "Inscription à un événement",
  subtitle: "Sous-titre",
  fileUploader: {
    message: "Déposez un fichier, ou cliquez pour le sélectionner.",
    invalidExtension: ({ named }) => `Le fichier "${named('name')}" n'a pas une extension valide.`,
    multipleDisabled: "Un seul fichier peut être sélectionné",
    nDocumentRequired: ({ named }) => `Au moins ${named('minRequired')} documents sont requis`,
    documentRequired: "Le document est obligatoire.",
  },
  error: {
    message: "Une erreur est survenue. Veuillez contacter l'Ordre.",
    close: "Fermer",
    title: "Attention",
  },
}